import { FullStoryAPI } from '@zapier/react-fullstory';
export const emitFullStoryEvent = (properties) => {
    FullStoryAPI('event', properties.interaction_name, properties);
};
//# sourceMappingURL=fullStoryEvents.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
